import { DocusignSignedStatus } from '~/utils/store';
import { TRACK, trackEvent } from '~/utils/tracking';
import { UnparsedQueryParams } from '../../types';

// event query params defined in docusign developers docs here:
// https://developers.docusign.com/docs/esign-rest-api/reference/envelopes/envelopeviews/createrecipient/#schema__recipientviewrequest_returnurl

const docuSignEventQueryParams = [
  'access_code_failed',
  'cancel',
  'decline',
  'exception',
  'fax_pending',
  'id_check_failed',
  'session_timeout',
  'signing_complete',
  'ttl_expired',
  'viewing_complete',
];

export const handleDocusign = ({ params: { event } }: { params: UnparsedQueryParams }) => {
  if (!event || !docuSignEventQueryParams.includes(event)) return;
  trackEvent(TRACK.ipaContractReturnedFromDocusign, { docusignEvent: event });
  return { signedStatus: event as DocusignSignedStatus };
};
